import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

//Css
import classes from "./Signin.module.css";
// Local
import CustomCard from "../../components/UI/Cards/CustomCard";
import {
  Text,
  Container,
  Button,
  InputCode,
  Spinner,
  Notifications,
  Icon,
} from "@jds/core";
import useInput from "../../hooks/use-input";
import { validatePassword } from "../../util/validation";
import useApiHttp from "../../hooks/use-http";
import { bytesToGB, getDeviceDetails } from "../../util/helper";
import { setImageAuth } from "../../util/imageHeaders";

export default function Otp(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = props.authData || location.state || {};
  const { phoneNumber, countryCode, channel = "mobile", email } = authData;
  const [step, setStep] = useState(0);
  const [resendCountdown, setResendCountdown] = useState(25);
  const [staySignedIn, setStaySignedIn] = useState(false);
  const [userAccounts, setUserAccounts] = useState([]);
  const [userId, setUserId] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const otpInputContainerRef = useRef(null);

  const {
    value: otp,
    isValid: isValidOtp,
    hasError: otpError,
    valueChangeHandler: otpChangeHandler,
    inputBlurHandler: otpBlurHandler,
    reset: resetOtp,
  } = useInput(validatePassword);
  const { sendRequest: verifyUserOtp, isLoading: verifyOtpLoading } =
    useApiHttp();
  const { sendRequest: userIdLogin, isLoading: userIdLoginLoading } =
    useApiHttp();
  const { sendRequest: resendOtp, isLoading: resendOTPLoading } = useApiHttp();

  const isValidForm = !isValidOtp;
  const handleOtpPaste = (event) => {
    const pastedOtp = event.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (!pastedOtp) return;

    event.preventDefault();
    otpChangeHandler({
      target: {
        value: pastedOtp,
      },
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    let deviceDetails = getDeviceDetails();

    if (channel === "email") {
      verifyUserOtp(
        {
          base: "JCAPI",
          isBearer: false,
          url: "/account/otp/login ",
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            "X-Api-Key": process.env.REACT_APP_APIKEY,
            "X-App-Secret": process.env.REACT_APP_APPSECRET,
            "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
            "X-Device-Type": process.env.REACT_APP_DEVICETYPE,
          },
          body: {
            emailId: email,
            otp,
            deviceType: "W",
            deviceInfo: {
              model: "browser",
              deviceName: "Web Device",
              platformType: deviceDetails?.platformType || "Chrome",
              platformVersion: deviceDetails?.platformVersion || "",
              type: "browser",
              isWebClient: true,
            },
            isStaySignIn: false,
          },
        },
        null,
        (data) => {
          const loginData = data?.data || data;
          console.log("hello==>", loginData);
          if (data?.jcJWT) {
            navigate(
              `/login?jwt=${data?.jcJWT}&dcCode=${data?.dcGroupCode?.toLowerCase()}`,
            );
          } else {
            Notifications.toast.success({
              id: "email-verify-otp",
              title: data?.message || "OTP verified successfully",
            });
          }
        },
        (_, data) =>
          Notifications.toast.error({
            id: "email-verify-otp",
            title: data?.message || data?.error,
          }),
      );
      return;
    }
    verifyUserOtp(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/jioid/verifyotp `,
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
          "X-Device-Key": props.deviceKey,
          "X-Device-Type": "W",
        },
        body: {
          // countryCode: countryCode,
          mobileNumber: "+91" + phoneNumber,
          otp: otp,
          isMnr: "Y",
        },
      },
      null,
      (data) => {
        if (data?.userAccounts?.length == 1) {
          setRequestId(data?.requestId);
          setUserId(data?.userAccounts[0]?.userId);
          handleUserIdLogin(data?.userAccounts[0]?.userId, data?.requestId);
        } else {
          setRequestId(data?.requestId);
          setUserAccounts(data?.userAccounts);
          setStep(1);
        }
      },
      (_, data) => {
        Notifications.toast.error({ id: "verify-otp", title: data?.error });
      },
    );
  };

  const handleUserIdLogin = (userId, requestId) => {
    let deviceDetails = getDeviceDetails();
    userIdLogin(
      {
        base: "JCAPI",
        isBearer: false,
        url: `account/jioid/useridlogin`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": process.env.REACT_APP_APIKEY,
          "X-App-Secret": process.env.REACT_APP_APPSECRET,
          "X-Client-Details": process.env.REACT_APP_CLIENTDETAILS,
        },
        body: {
          userId,
          requestId,
          deviceType: "W",
          mobileNumber: "+91" + phoneNumber,
          deviceInfo: {
            deviceKey: props.deviceKey,
            model: "browser",
            deviceName: "Web Device",
            platformType: deviceDetails?.platformType || "Chrome",
            platformVersion: deviceDetails?.platformVersion || "",
            type: "browser",
            isWebClient: true,
          },
        },
        credentials: "include",
      },
      null,
      (data) => {
        setImageAuth({
          userId: data?.userId,
          deviceKey: data?.deviceKey,
          accessToken: data?.authToken?.accessToken,
        });
        if (props.registrationEventId) {
          navigate(
            `/user-registered?jwt=${encodeURIComponent(data?.jcJWT || "")}&eventId=${encodeURIComponent(props.registrationEventId)}&dcCode=${encodeURIComponent(data?.dcGroupCode?.toLowerCase() || "")}`,
            { replace: true },
          );
        } else {
          navigate(
            `/login?jwt=${data?.jcJWT}&dcCode=${data?.dcGroupCode?.toLowerCase()}`,
          );
        }
      },
      (_, data) => {
        Notifications.toast.error({ id: "userid-login", title: data?.error });
        navigate("/");
      },
    );
  };
  const resendOTPHandler = () => {
    if (resendCountdown > 0) return;

    if (channel === "email") {
      props.handleEmailSubmit?.();
    } else {
      props.handleSubmit?.();
    }
    setResendCountdown(25);
  };
  useEffect(() => {
    if (resendCountdown <= 0) return undefined;
    const timer = setTimeout(
      () => setResendCountdown((seconds) => seconds - 1),
      1000,
    );
    return () => clearTimeout(timer);
  }, [resendCountdown]);

  useEffect(() => {
    if (!props.registrationEventId || step !== 0) return;
    otpInputContainerRef.current?.querySelector("input")?.focus();
  }, [props.registrationEventId, step]);

  const goBack = () => {
    if (props.onBack) props.onBack();
    else navigate("/auth/signin");
  };
  return (
    <CustomCard
      sx={{
        padding: props.registrationEventId ? "24px" : "32px",
        width: props.registrationEventId ? "100%" : undefined,
        maxWidth: props.registrationEventId ? "360px" : "484px",
        minWidth: props.registrationEventId ? "min(100%, 360px)" : "484px",
        minHeight: props.registrationEventId
          ? "min(820px, calc(100vh - 142px))"
          : "585px",
        "@media screen and (max-width: 1024px)": {
          minWidth: "unset",
        },
        ...(props.registrationEventId && {
          "@media screen and (max-width: 767px)": {
            minHeight: "calc(100vh - 124px)",
            borderRadius: 0,
            boxShadow: "none",
          },
        }),
      }}>
      <div>
        {step == 0 && (
          <Container
            direction="column"
            fullWidth
            style={{ justifyContent: "" }}>
            <Container direction="column" gap={16} fullWidth>
              <Container
                direction="row"
                gap={8}
                fullWidth
                verticalAlign="center">
                <Button
                  type="button"
                  kind="tertiary"
                  icon="IcArrowBack"
                  aria-label="Back to sign in"
                  onClick={goBack}
                />
                <Text appearance="heading-xs">OTP verification</Text>
              </Container>
              <Container direction="column" gap={0} className="">
                <Text appearance="body-s">Enter the OTP sent to you on</Text>
                <Text appearance="body-s">
                  {channel === "email" ? email : `${countryCode}${phoneNumber}`}
                </Text>
                {channel === "mobile" && (
                  <Link
                    to={"/auth/signin"}
                    onClick={(event) => {
                      if (props.onBack) {
                        event.preventDefault();
                        goBack();
                      }
                    }}>
                    <Text appearance="body-s-link">Change number</Text>
                  </Link>
                )}
              </Container>
            </Container>
            <Container
              direction="column"
              fullWidth
              style={{ margin: "48px 0 24px 0" }}>
              <div
                ref={otpInputContainerRef}
                onPaste={handleOtpPaste}
                onKeyDown={(e) => {
                  if (e.key == "Enter") handleSubmit();
                }}>
                <InputCode
                  name="otp"
                  value={otp}
                  onChange={(e) => {
                    otpChangeHandler(e);
                  }}
                  onPaste={handleOtpPaste}
                  onBlur={otpBlurHandler}
                  stateText="invalid otp"
                  state={otpError ? "error" : ""}
                  codeLength={6}
                />
              </div>

              {/* <InputCode codeLength={6} /> */}
            </Container>

            <Container
              direction="row"
              fullWidth
              style={{ alignItems: "center", justifyContent: "space-between" }}>
              {!props.registrationEventId && (
                <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <input
                    type="checkbox"
                    checked={staySignedIn}
                    onChange={(event) => setStaySignedIn(event.target.checked)}
                  />
                  <Text appearance="body-s">Stay Signed In</Text>
                </label>
              )}
              <Button
                type="button"
                kind="tertiary"
                label={
                  resendCountdown > 0
                    ? `Request new OTP in ${resendCountdown} secs`
                    : "Request new OTP"
                }
                loading={resendOTPLoading}
                disabled={resendCountdown > 0 || resendOTPLoading}
                onClick={resendOTPHandler}
              />
            </Container>
            <Container style={{ marginTop: "213px" }} fullWidth>
              <Button
                onClick={handleSubmit}
                fullWidth
                disabled={isValidForm || verifyOtpLoading}
                size="large"
                kind={verifyOtpLoading ? "secondary" : "primary"}>
                {verifyOtpLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Verify"
                )}
              </Button>
            </Container>
          </Container>
        )}
        {step == 1 && (
          <Container
            direction="column"
            fullWidth
            style={{ justifyContent: "" }}>
            <Container direction="column" gap={16} fullWidth>
              <Text appearance="heading-xs">Select account</Text>
              <Container direction="column" gap={0} className="">
                <Text appearance="body-s">
                  This number is linked with multiple Jio accounts.
                </Text>
              </Container>
            </Container>
            <div className={`${classes["access-input-container"]}`}>
              {userAccounts.map((userAccount, i) => (
                <div
                  className={`${classes["access-input-card"]} ${userId === userAccount.userId ? classes["active"] : classes["unactive"]}`}
                  onClick={() => {
                    setUserId(userAccount.userId);
                  }}>
                  <div className={`${classes["icon"]}`}>
                    <Icon
                      ic={
                        userAccount.productType === "Mobile"
                          ? "IcSim"
                          : "IcUser"
                      }
                      kind="background"
                      size="large"
                    />
                  </div>
                  <div className={`${classes["input-card-info"]}`}>
                    <p className={`${classes["input-card-dec"]}`}>
                      {userAccount.productType}
                    </p>
                    <p className={`${classes["input-card-title"]}`}>
                      {userAccount.phoneNumber}
                    </p>
                    <p className={`${classes["input-card-dec"]}`}>
                      {bytesToGB(userAccount.allocatedSpace)}GB entitlement
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <Container
              direction="row"
              fullWidth
              style={{ justifyContent: "flex-end" }}>
              {/* <Text appearance="body-s-link">Resend OTP</Text> */}
            </Container>
            <Container style={{ marginTop: "213px" }} fullWidth>
              <Button
                onClick={() => handleUserIdLogin(userId, requestId)}
                fullWidth
                disabled={userId === null}
                size="large"
                kind={userIdLoginLoading ? "secondary" : "primary"}>
                {userIdLoginLoading ? (
                  <Spinner kind="vibrant" label="Loading..." size="small" />
                ) : (
                  "Continue"
                )}
              </Button>
            </Container>
          </Container>
        )}
      </div>
    </CustomCard>
  );
}
